function hex2rgb(hex) {
  let h = String(hex || '').replace('#', '');
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  const n = parseInt(h, 16);
  if (Number.isNaN(n)) return [37, 99, 235];
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function shiftRgb(hex, amount) {
  const [r, g, b] = hex2rgb(hex);
  const clamp = (v) => Math.max(0, Math.min(255, v));
  return [clamp(r + amount), clamp(g + amount), clamp(b + amount)];
}

function rgbStr([r, g, b]) {
  return `rgb(${r},${g},${b})`;
}

/** 0 = square, 50 = circle (percent of box). */
export function clampCookieIconRadius(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 50;
  return Math.max(0, Math.min(50, Math.round(n)));
}

/** 0 = flat, 100 = full 3D shadow. */
export function clampCookieIconShadow(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 100;
  return Math.max(0, Math.min(100, Math.round(n)));
}

export function cookieIconBorderRadiusCss(radius) {
  return `${clampCookieIconRadius(radius)}%`;
}

export function cookieIcon3dButtonBackground(bg, amount = 100) {
  const t = clampCookieIconShadow(amount) / 100;
  if (t <= 0) return bg;
  const lighter = rgbStr(shiftRgb(bg, Math.round(14 * t)));
  const darker = rgbStr(shiftRgb(bg, Math.round(-18 * t)));
  return `linear-gradient(160deg, ${lighter} 0%, ${bg} 48%, ${darker} 100%)`;
}

export function cookieIcon3dButtonShadow(isSide = false, amount = 100) {
  const t = clampCookieIconShadow(amount) / 100;
  if (t <= 0) return 'none';
  const y = (isSide ? 2 : 3) * t;
  const blur = (isSide ? 8 : 10) * t;
  const outerOp = (isSide ? 0.16 : 0.18) * t;
  const insetLight = `inset 0 1px 0 rgba(255,255,255,${0.16 * t})`;
  const insetDark = `inset 0 -1px ${3 * t}px rgba(0,0,0,${0.08 * t})`;
  return `0 ${y}px ${blur}px rgba(0,0,0,${outerOp}), ${insetLight}, ${insetDark}`;
}

export function cookieIcon3dButtonHoverShadow(isSide = false, amount = 100) {
  const t = clampCookieIconShadow(amount) / 100;
  if (t <= 0) return 'none';
  const y = (isSide ? 3 : 4) * t;
  const blur = (isSide ? 10 : 12) * t;
  const outerOp = (isSide ? 0.2 : 0.22) * t;
  const insetLight = `inset 0 1px 0 rgba(255,255,255,${0.16 * t})`;
  const insetDark = `inset 0 -1px ${3 * t}px rgba(0,0,0,${0.08 * t})`;
  return `0 ${y}px ${blur}px rgba(0,0,0,${outerOp}), ${insetLight}, ${insetDark}`;
}

export function cookieIcon3dButtonStyle(bg, isSide = false, amount = 100) {
  return {
    background: cookieIcon3dButtonBackground(bg, amount),
    boxShadow: cookieIcon3dButtonShadow(isSide, amount),
  };
}
